import {axios} from '../../services/axios';

export default function getDRServiceProfileDialPlans({scope}) {
    return axios.get(
        `/ServiceProfiles/DirectRouting/${scope}/DialPlans/Available`,
    );
}
